module.exports = __webpack_public_path__ + "static/media/placeholder-camera.29c96cac.svg";